(function () {
  const submenuParents = document.querySelectorAll('[data-footer-link-has-submenu]');

  const openSubmenu = function (event) {
    const parent = event.currentTarget;
    const link = parent.querySelector(':scope > a');

    setSubmenuPositioning(parent);

    link.setAttribute('aria-expanded', 'true');
  };

  const closeSubmenu = function (event) {
    const parent = event.currentTarget;
    const link = parent.querySelector(':scope > a');

    link.setAttribute('aria-expanded', 'false');
  };

  const setSubmenuPositioning = function () {
    submenuParents.forEach(function (parent) {
      const link = parent.querySelector(':scope > a');
      const submenu = parent.querySelector(':scope > .linklist__submenu');

      Popper.createPopper(link, submenu, {
        placement: 'top',
      });
    });
  };

  submenuParents.forEach(function (parent) {
    parent.addEventListener('mouseover', openSubmenu);
    parent.addEventListener('mouseleave', closeSubmenu);
  });
})();
